<template>
	<div class="cents">
		<van-nav-bar :title=this.$route.query.serial_number left-arrow safe-area-inset-top
			style="background-color: #1ABC9C;" @click-left="goto"/>
		<div class="setList">
			<div class="setItem" @click="handleSet(0)">
				<img src="../assets/images/user/u795.png" class="setItem-icon" />
				<div>{{this.$t('wlgl')}}</div>
			</div>
			<div class="setItem" @click="handleSet(4)" v-if="UserInfo.person_type !=1">
				<img src="../images/staff.png" class="setItem-icon" />
				<div>{{this.$t('yggl')}}</div>
			</div>
			<div v-show='isShow2' class="setItemBox">
				<div class="setItemAdmin" v-for="(item,index) in staffList" @click="toAdmin(item.id)" :key="item.id">
					<div>{{item.value}}</div>
				</div>
			</div>
			<div class="setItem" @click="handleSet(2)">
				<img src="../assets/images/u27.png" class="setItem-icon" />
				<div>{{this.$t('qxfp')}}</div>
			</div>
			<div class="setItem" @click="handleSet(3)">
				<img src="../images/update.png" class="setItem-icon" />
				<div>{{this.$t('gxqx')}}</div>
			</div>
			<div class="setItem" @click="handleSet(5)">
				<img src="../images/restart.png" class="setItem-icon" />
				<div>{{this.$t('cqsb')}}</div>
			</div>
			<div class="setItem" @click="handleSet(1)">
				<img src="../images/u1981.svg" class="setItem-icon" />
				<div>{{this.$t('cshsb')}}</div>
			</div>
			<div class="setItem" @click="handleSet(6)">
				<img src="../images/delete.png" class="setItem-icon" />
				<div>{{this.$t('scsb')}}</div>
			</div>
			<div class="setItem" @click="handleSet(7)">
				<!-- <img src="../images/delete.png" class="setItem-icon" /> -->
				<van-icon name="coupon-o" size="28" class="setItem-icon" />
				<div>{{this.$t('免审参数')}}</div>
			</div>
		</div>
		<!-- 初始化设备 弹窗 -->
		<popup :title='popTitle' :popState='popState' @popClose='popClose' @popConfirm='popConfirm' :placeholder="$t('qsryhmm')" :btnTxt="$t('qr')">
			<div>
				<div class="tips">{{this.$t('cshPopTips')}}</div>
				<div class="tipsdang">{{this.$t('qjscz')}}</div>
			</div>
		</popup>
		<!-- 更新权限 弹窗 -->
		<popup :title='popTitle' :popState='popUpdateState' @popClose='popUpdateClose' @popConfirm='popUpdateConfirm' :inputState='inputState' :btnTxt="$t('qr')">
			<div>
				<div class="tips">{{this.$t('qrgxqxm')}}</div>
			</div>
		</popup>
		<!-- 重启设备 弹窗 -->
		<popup :title='popTitle' :popState='popRestartState' @popClose='popRstartClose' @popConfirm='popRestartConfirm' :inputState='inputState'  :btnTxt="$t('qr')">
			<div>
				<div class="tips">{{this.$t('qrcqsbm')}}</div>
			</div>
		</popup>
		<!-- 删除弹窗 -->
		<popup :title='popTitle' :popState='delState' :nameState='nameState' @popClose='popDelClose' @popConfirm='popDelConfirm' :nameplaceholder="$t('qsryhm')" :placeholder="$t('qsryhmm')" :btnTxt="$t('qr')">
			<div>
				<div class="tips">{{this.$t('dqczjscsb')}}</div>
				<div class="tipsdang">{{this.$t('qjscz')}}</div>
			</div>
		</popup>
	</div>
</template>

<script>
	import popup from '@/components/singlePopup.vue'
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				powerList: [{
					id: 6,
					value: this.$t('shgl')
				}, {
					id: 7,
					value: this.$t('qxfp')
				}],
				staffList:[
					{
						id: 0,
						value: this.$t('bmgl')
					}, {
						id: 1,
						value: this.$t('rygl')
					}, 
				],
				isShow: false,
				isShow2:false,
				inputState:false,
				popUpdateState:false,
				popRestartState:false,
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				popTitle: this.$t('ts'), // 初始化设备 弹窗 title
				popState: false, // 初始化设备 弹窗 状态
				delState:false,
				nameState:true
			}
		},
		components: {
			popup,
		},
		created() {
			this.$route.query.deviceInfo = JSON.parse(this.$route.query.deviceInfo)
			console.log(this.$route.query.deviceInfo);
		},
		methods: {
			// 删除确认
			popDelConfirm(e){
				console.log(e)
				let data = {
					method:'co.device.del',
					name:e[1],
					id:this.$route.query.deviceInfo.id,
					password:this.$md5(e[0]),
					mqtt_login_id:this.UserInfo.mqtt_login_id
				}
				this.$https(data).then(res=>{
					if(res.data.code==0){
						Toast.success(this.$t('sbsccg'))
						this.$router.push(`/equipment`)
					}else if(res.data.code==-3){
						Toast.fail(this.$t('sbbcz'))
					}else if(res.data.code==-5){
						Toast.fail(this.$t('sbyc'))
					}else if(res.data.code==-8){
						Toast.fail(this.$t('mqxhzhmmcw'))
					}else{
						Toast.fail(this.$t('gxqxsb')+res.data.code)
					}
					this.delState = false
				})
			},
			// 删除弹窗 关闭
			popDelClose(){
				this.delState = false
			},
			// 更新权限 确认按钮
			popUpdateConfirm(){
				let data = {
					method:'co.wx.device.update',
					device_id:this.$route.query.deviceInfo.id,
					manager_id:this.UserInfo.manager_id,
					user_id:this.UserInfo.user_id,
					password:this.UserInfo.password
				}
				this.$serve(data).then(res=>{
					if(res.data.code==0){
						Toast.success(this.$t('gxqxcg'))
					}else if(res.data.code==-3){
						Toast.fail(this.$t('sfyzgq'))
					}else if(res.data.code==-5){
						Toast.fail(this.$t('sbyc'))
					}else{
						Toast.fail(this.$t('gxqxsb')+res.data.code)
					}
					this.popUpdateState = false
				})
			},
			// 更新权限 弹窗关闭
			popUpdateClose(){
				this.popUpdateState = false
			},
			// 重启设备 弹窗按钮
			popRestartConfirm(){
				let data = {
					method:'co.wx.device.reset',
					device_id:this.$route.query.deviceInfo.id,
					manager_id:this.UserInfo.manager_id,
					user_id:this.UserInfo.user_id,
					password:this.UserInfo.password
				}
				this.$serve(data).then(res=>{
					if(res.data.code==0){
						Toast.success(this.$t('gxqxcg'))
					}else if(res.data.code==-3){
						Toast.fail(this.$t('sfyzgq'))
					}else if(res.data.code==-5){
						Toast.fail(this.$t('sbyc'))
					}else{
						Toast.fail(this.$t('gxqxsb')+res.data.code)
					}
					this.popRestartState = false
				})
			},
			// 重启设备 弹窗关闭
			popRstartClose(){
				this.popRestartState = false
			},
			// 确认 删除
			popConfirm(e) {
				console.log(e[0]);
				if (e[0] == '') {
					Toast.fail(this.$t('qsryhmm'))
				} else {
					let data = {
						method: 'co.wx.clear.device',
						password: this.$md5(e[0]),
						device_id: this.$route.query.deviceInfo.id,
						login_user_id: this.UserInfo.user_id
					}
					this.$serve(data).then(res => {
						if (res.data.code == 0) {
							Toast.success(this.$t('qcsbcg'))
							this.popState = false
						} else if (res.data.code == -3) {
							Toast.fail(this.$t('mmcw'))
						} else if (res.data.code == -5) {
							Toast.fail(this.$t('sbbzxhyc'))
						}
					})
				}
			},
			// 关闭初始化 弹窗
			popClose() {
				this.popState = false
			},
			goto() {
				this.$router.go(-1)
			},
			handleSet(i) {
				console.log(i)
				if (i == 2) { // 门禁权限
					this.$router.push(`/admin/power?deviceId=${this.$route.query.deviceInfo.id}`)
				} else if (i == 1) { //初始化设备
					this.popState = true
				} else if (i == 0) {
					this.$router.push('/network')
				}else if(i == 4){
					this.isShow2 = !this.isShow2
				}else if(i == 3){
					this.popUpdateState = true
				}else if(i == 5){
					this.popRestartState = true
				}else if(i==6){
					this.delState = true
				}else if(i == 7){ // 免审参数
					this.$router.push(`/Exempt?deviceId=${this.$route.query.deviceInfo.id}`)
				}
			},
			toAdmin(i) {
				console.log(i)
				if (i == 0) {
					this.$router.push(`/admin/dept`)
				} else if (i == 1) {
					this.$router.push(`/admin/person`)
				} else if (i == 2) {
					this.$router.push(`/admin/key?deviceId=${this.$route.query.deviceInfo.id}`)
				} else if (i == 3) {
					this.$router.push(`/admin/doorCard?deviceId=${this.$route.query.deviceInfo.id}`)
				} else if (i == 4) {
					this.$router.push(`/admin/face?deviceId=${this.$route.query.deviceInfo.id}`)
				} else if (i == 5) {
					this.$router.push(`/admin/password?deviceId=${this.$route.query.deviceInfo.id}`)
				} else if (i == 6) {
					this.$router.push(`/admin/examine?deviceId=${this.$route.query.deviceInfo.id}`)
				}else if(i == 7){
					this.$router.push(`/admin/power?deviceId=${this.$route.query.deviceInfo.id}`)
				}
			}
		},

	}
</script>

<style scoped>
	.tips {
		width: 70%;
		margin: 0 auto;
		text-align: center;
		line-height: 30px;
	}

	.tipsdang {
		text-align: center;
		color: red;
		margin-bottom: 10px;
	}

	.setList {
		padding: 20px 30px;
	}

	.setItem {
		display: flex;
		height: 40px;
		align-items: center;
		line-height: 40px;
		border-bottom: 1px solid #ccc;
	}
	
	.setItemBox{
		background-color: #fff;
	}

	.setItemAdmin {
		display: flex;
		height: 40px;
		align-items: center;
		line-height: 40px;
		border-bottom: 1px solid #ccc;
		padding-left: 35px;
	}

	.setItem-icon {
		margin-right: 10px;
		width: 25px;
		height: 25px;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
